import {FC, ReactNode} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, Divider, styled} from '@mui/material';

interface Props {
  title: string;
  children?: ReactNode;
  footer?: ReactNode;
  open: boolean;
}

export const ContractModal: FC<Props> = ({title, footer, children, open}) => {
  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <DialogTitle>{title}</DialogTitle>
      <StyledDialogContent>
        <StyledForm>{children}</StyledForm>
      </StyledDialogContent>
      <Divider />
      <DialogActions>{footer}</DialogActions>
    </Dialog>
  );
};

const StyledDialogContent = styled(DialogContent)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  paddingTop: 16,
  paddingBottom: 28,
});

const StyledForm = styled('form')({
  marginTop: 12,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});
